import { SUGGESTED } from './TippingStep';

/**
 * Step logic for onboarding, kept out of the container so it can be tested.
 *
 * Order is Profile, Tours, Tipping. Tours only appears for a guide the backend
 * says must pick tours (GET tip-direct-tours/selection-status, the same rule
 * as the standalone tour picker), so company owners and guides in companies
 * without linked tours see two steps. Profile and Tipping keep their
 * `profile.onboarding` flags; Tours has no flag of its own because "has a live
 * tour" is the real state and the backend already answers it.
 */

export const STEP_LABELS = { profile: 'Profile', tours: 'Tours', tipping: 'Tipping' };

export const buildSteps = includeTours =>
  ['profile', ...(includeTours ? ['tours'] : []), 'tipping'].map(key => ({
    key,
    label: STEP_LABELS[key]
  }));

/** Where to resume, or null when nothing is left. */
export const firstIncompleteStep = (onboarding = {}, toursRequired = false) => {
  if (!onboarding.profile) return 'profile';
  if (toursRequired) return 'tours';
  if (!onboarding.tipping) return 'tipping';
  return null;
};

const positive = value => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : null;
};

/** A guide's saved amounts, with suggestions in place of zeros or gaps. */
export const initialAmounts = (paymentOptions = {}) => {
  const quick = paymentOptions.quickPaymentAmounts || {};
  return {
    bespoke: positive(paymentOptions.defaultPaymentAmount) || SUGGESTED.bespoke,
    good: positive(quick.good) || SUGGESTED.good,
    great: positive(quick.great) || SUGGESTED.great,
    amazing: positive(quick.amazing) || SUGGESTED.amazing
  };
};

/** The paymentOptions to save, in the shape the profile endpoint expects. */
export const paymentOptionsFor = (mode, amounts, previous = {}) => ({
  ...previous,
  paymentOptionEnabled: mode,
  defaultPaymentAmount: Number(amounts.bespoke),
  quickPaymentAmounts: {
    good: Number(amounts.good),
    great: Number(amounts.great),
    amazing: Number(amounts.amazing)
  }
});
